import { ActionCreator } from 'redux';

import {
  ISetScenarioBooleanProp,
  ISetScenarioNumberProp,
  ScenarioActionTypes,
} from '../types/scenarios'

// Do we make a new function for every prop? For now, no
export const setScenarioBoolean: ActionCreator<ISetScenarioBooleanProp> = (propName, value, scenarioKey) => ({
  payload: {
    propName,
    scenarioKey,
    value
  },
  type: ScenarioActionTypes.SET_BOOLEAN_PROP,
 })

export const setScenarioNumber: ActionCreator<ISetScenarioNumberProp> = (propName, value, scenarioKey) => ({
  payload: {
    propName,
    scenarioKey,
    value
  },
  type: ScenarioActionTypes.SET_NUMBER_PROP,
})



// WEBPACK FOOTER //
// ./src/store/actions/scenarios.ts